//common
import React from 'react';
const columns = () =>
  [
    {
      title: "#",
      dataIndex: "stt",
      width: "45px",
      align: 'center'
    },
    {
      title: "Tên hạng mục",
      dataIndex: "ten",
      width:"150px"
     
    },
    {
      title: "Địa điểm",
      dataIndex: "diaDiem",
     
      width: "400px",
    },
    {
      title: "Tọa độ",
      dataIndex: "toaDo",
     
      width: "150px",
    },
    {
      title: "Diện tích",
      dataIndex: "dienTich",
      width: "80px",
    },
    {
      title: "Đơn vị diện tích",
      dataIndex: "dienTich_DonVi_Ten",
      width: "50px",
    },
  ].map(col => ({ ...col}));

export default columns;
